import { Amount } from '@app.styled';
import Text from '@components/Text/Text';
import styled from 'styled-components';

export const ServicingContainer = styled.div`
    display: flex;
    flex: 1;
    justify-content: space-between;
    align-items: flex-start;
`;

export const ButtonWrapper = styled('div')`
    display: flex;
    flex-direction: column;
    align-self: end;
    min-width: max-content;
    align-items: flex-end;
    align-items: center;
    text-align: center;
    button {
        &:not(:last-child) {
            margin-bottom: 15px;
        }
    }
    button:hover {
        background: ${({ theme: { colors } }) => colors.darkCyanBlue};
    }

    @media screen and (max-width: 992px) {
        button {
            max-width: 129px;
        }
    }

    @media screen and (min-width: 550px) and (max-width: 700px) {
        button {
            max-width: inherit;
        }
    }
`;

export const AccountText = styled.div`
    color: #222a34;
    font-size: 16px;
    letter-spacing: 0;
    line-height: 19px;
    &:not(:last-child) {
        margin-bottom: 10px;
    }
`;

export const ServicingDetails = styled.div`
    display: inline-flex;
    flex-direction: column;
`;

export const LoanBalance = styled.div`
    margin-bottom: 15px;
    font-size: 36px;
    font-weight: 300;
    letter-spacing: 0;
    line-height: 42px;
`;

export const LoanActivityInfo = styled.div`
    gap: 13px;
    display: flex;
    flex-direction: column;
    font-weight: 500;
    font-size: 14px;
`;

export const Vr = styled.div`
    width: 1px;
    border: 1px solid #979797;
    height: 157px;
    @media screen and (max-width: 800px) {
        display: none;
    }
`;

export const DateText = styled.div`
    color: #222a34;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 16px;
`;

export const AmoutText = styled.div`
    color: #656565;
    font-size: 14px;
    letter-spacing: 0;
    line-height: 16px;
    font-weight: normal;
`;

export const ServicingDetailsWrapper = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 43px;
`;

export const ServiceWrapper = styled.div`
    display: flex;
    gap: 34px;

    @media screen and (max-width: 800px) {
        flex-direction: column;
        gap: unset;
    }
`;

export const Hr = styled.hr`
    display: none;
    @media screen and (max-width: 800px) {
        display: block;
        margin: 20px 0;
    }
`;
